import { JSX } from 'react';
export const StethoscopeIcon = ({
  fill,
  className = 'pi-icon',
  ...props
}: {
  fill?: string;
  className?: string;
  props?: string[];
}): JSX.Element => {
  // TODO: add aria-label or aria-hidden attributes
  const color = fill || '#392B96';
  return (
    <svg
      width="57"
      height="40"
      viewBox="0 0 68 48"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      focusable="false"
      {...props}
    >
      <path
        d="M40.058 29.7397L29.5581 40.5888C26.7308 43.4231 22.8969 45.0153 18.8993 45.0153C14.9018 45.0153 11.0678 43.4231 8.24053 40.5888L6.05671 38.358C4.10578 36.4004 3.01011 33.7459 3.01074 30.9782C3.01106 29.6077 3.28051 28.2508 3.80372 26.9848C4.32693 25.7188 5.09364 24.5686 6.06009 23.5998C7.02654 22.6309 8.1738 21.8625 9.43635 21.3384C10.6989 20.8142 12.052 20.5446 13.4185 20.5449C16.1782 20.5456 18.8246 21.6456 20.7755 23.6031L24.0614 26.8986"
        stroke={color}
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M24.3996 33.5708C27.749 33.5708 30.4643 30.8477 30.4643 27.4885C30.4643 24.1294 27.749 21.4062 24.3996 21.4062C21.0502 21.4062 18.335 24.1294 18.335 27.4885C18.335 30.8477 21.0502 33.5708 24.3996 33.5708Z"
        fill={color}
      />
      <path
        d="M52.3899 12.1103C54.3727 12.1103 55.98 10.4983 55.98 8.50973C55.98 6.5212 54.3727 4.90918 52.3899 4.90918C50.4072 4.90918 48.7998 6.5212 48.7998 8.50973C48.7998 10.4983 50.4072 12.1103 52.3899 12.1103Z"
        fill={color}
      />
      <path
        d="M59.5637 19.3046C61.5465 19.3046 63.1539 17.6926 63.1539 15.7041C63.1539 13.7155 61.5465 12.1035 59.5637 12.1035C57.581 12.1035 55.9736 13.7155 55.9736 15.7041C55.9736 17.6926 57.581 19.3046 59.5637 19.3046Z"
        fill={color}
      />
      <path
        d="M58.117 14.6122L64.5806 21.1759L60.7335 25.0545C58.9242 26.8973 56.7679 28.3611 54.3897 29.361C52.0115 30.361 49.4589 30.877 46.8802 30.8791C44.6198 30.8379 42.3632 30.6795 40.1191 30.4045H39.5444L38.8278 28.5805C37.4614 24.9889 37.1511 21.0796 37.9337 17.3165C38.7163 13.5534 40.5588 10.0944 43.2427 7.35008L47.0898 3.45117L53.5466 10.0149"
        stroke={color}
        strokeWidth="3"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
